import { twMerge } from 'tailwind-merge';
import type { StepChild } from './types';

export const classes = {
  wrapper: 'place-between',
  step: 'text-sm font-medium transition-colors place-center rounded-xl py-1 px-4 select-none',
  activeStep:
    'text-orange-3 bg-orange-1/30 dark:bg-orange-3/[0.16] font-semibold text-sm tracking-wide cursor-default',
  inactiveStep: 'text-grey-6 bg-white dark:text-mauve-3 dark:bg-white/[0.06]',
  completedStep:
    'text-orange-2 hover:text-orange-3 hover:bg-orange-1/30 dark:hover:bg-orange-3/[0.16] cursor-pointer',
  spacer: 'grow h-0 border-b-2 border-grey-4 dark:border-white/10 mx-1',
  filledSpacer: 'border-orange-2/60',
  enabled:
    'cursor-pointer hover:bg-grey-2 dark:hover:bg-white/[0.1] hover:text-grey-7 dark:hover:text-mauve-2',
  disabled: 'cursor-not-allowed hover:bg-white dark:hover:bg-white/[0.06]',
};

export function getInitialStep(
  steps: StepChild[],
  defaultStep?: string
): string {
  // If an invalid step name is provided, default to the first step
  const stepNames = getStepNames(steps);
  if (!defaultStep || !stepNames.includes(defaultStep)) return stepNames[0];
  return defaultStep;
}

export function getMargins(steps: any[], i: number) {
  if (i === 0) return 'mr-1';
  else if (i === steps.length - 1) return 'ml-1';
  else return 'mx-1';
}

export function getStepClasses(
  step: StepChild,
  index: number,
  children: StepChild[],
  name: string,
  activeStep: string
) {
  const activeIndex = children.findIndex(
    ({ props }) => props.name === activeStep
  );
  let classList = [classes.step];
  if (activeStep === step.props.name) {
    classList.push(classes.activeStep, `${name}-active-step`);
  } else if (index < activeIndex) {
    classList.push(classes.completedStep);
  } else {
    classList.push(
      classes.inactiveStep,
      step.props.disabled ? classes.disabled : classes.enabled
    );
  }
  return twMerge(...classList, getMargins(children, index));
}

export function getSpacerClasses(
  index: number,
  steps: StepChild[],
  activeStep: string
) {
  const activeIndex = steps.findIndex(({ props }) => props.name === activeStep);
  let classList = [classes.spacer];
  if (index < activeIndex) {
    classList.push(classes.filledSpacer);
  }
  return twMerge(...classList);
}

export function isStepChanged(
  steps: StepChild[],
  activeStep: string,
  defaultStep: string
) {
  return (
    activeStep !== defaultStep && getStepNames(steps).includes(defaultStep)
  );
}

function getStepNames(steps: StepChild[]) {
  return steps.map(({ props }) => props.name);
}
